import React from 'react';
import '.././CompanyNews.scss';
import { Link } from 'react-router-dom'
import { companyNew } from '@/fetch'
class CompanyNews extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      companyNewsdata: [],
      scrollHeight: 0,
      off_on: false,
    }
    this.startx = null;                 //触摸起始点x轴坐标
    this.starty = null;                 //触摸起始点y轴坐标
    this.zise = 1;
  }
  componentDidMount() {
    let that = this;
    companyNew.getCompanyNewsByCondition({ page: that.zise, size: 10 }).then(res => {
      if (JSON.stringify(res.page.content) !== '[]') {
        that.setState({ companyNewsdata: that.state.companyNewsdata.concat(res.page.content) }, () => { });
        that.setState({ off_on: true })
        that.forceUpdate();
      } else {
        that.setState({ off_on: false })
      }
    }).catch(err => console.log(err))
  }
  getAngle(angx, angy) {
    return Math.atan2(angy, angx) * 180 / Math.PI;
  };
  //根据起点终点返回方向 1向上 2向下 3向左 4向右 0未滑动
  getDirection(startx, starty, endx, endy) {
    var angx = endx - startx;
    var angy = endy - starty;
    var result = 0;

    //如果滑动距离太短
    if (Math.abs(angx) < 2 && Math.abs(angy) < 2) {
      return result;
    }

    var angle = this.getAngle(angx, angy);
    if (angle >= -135 && angle <= -45) {
      result = 1;
    } else if (angle > 45 && angle < 135) {
      result = 2;
    } else if ((angle >= 135 && angle <= 180) || (angle >= -180 && angle < -135)) {
      result = 3;
    } else if (angle >= -45 && angle <= 45) {
      result = 4;
    }

    return result;
  }
  touchStart(e) {
    e.preventDefault();
    this.startx = e.touches[0].pageX;
    this.starty = e.touches[0].pageY;
  }
  touchEnd(e) {
    e.stopPropagation();
    let that = this;
    var endx, endy;
    endx = e.changedTouches[0].pageX;
    endy = e.changedTouches[0].pageY;
    var direction = this.getDirection(this.startx, this.starty, endx, endy);
    switch (direction) {
      // case 0:
      //     // console.log('没动')
      //     break;
      case 1:
        if (that.state.off_on) {
          that.state.off_on = false;
          that.zise++;
          companyNew.getCompanyNewsByCondition({ page: that.zise, size: 10 }).then(res => {
            if (JSON.stringify(res.page.content) !== '[]') {
              that.setState({ companyNewsdata: that.state.companyNewsdata.concat(res.page.content) }, () => { });
              that.setState({ off_on: true })
              that.forceUpdate();
            } else {
              that.setState({ off_on: false })
            }
          })
        }
        break;
      // case 2:
      //     console.log('下')
      //     break;
      // case 3:
      //     console.log('左')
      //     break;
      // case 4:
      //     console.log('又')
      //     break;
      default:
    }

  }
  render() {
    return (
      <div className='CompanyNews' onTouchStart={this.touchStart.bind(this)} onTouchEnd={this.touchEnd.bind(this)}>
        <main className="CompanyNews-body" >
          <ul>
            {
              this.state.companyNewsdata.map((item, index) =>
                <li key={index}>
                  <Link to={'/Introduction/CompanyNews/NewsDetail/' + item.id}>
                    <h4>
                      {item.title.length < 40
                        ? item.title
                        : item.title.substring(0, 40) + '...'}
                    </h4>
                    <p>发布时间:{item.publishAt.split(' ')[0]}</p>
                  </Link>

                </li>
              )
            }
          </ul>
        </main>
      </div>
    )
  }
}
export default CompanyNews;
